export const FONTS = {
  FONT_1: "Montserrat",
};
